import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const StyledRadioRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export const StyledRadioText = styled(Typography)(({ theme }) => ({
  fontSize: '1em',
  fontWeight: 'bold',
  color: theme.palette.primary.dark,
}));
